module.exports = __webpack_public_path__ + "b61574bfea1e9386c59de68e88d50b67.png";